import React from "react";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { event } from "../../components/reactGA";
import config from "../../Config";
import PageHeader from "../PageHeader";
import i18n from "../../i18n";

class NoWifiPage extends React.Component {

	render(){

		return <div className="wrapper">
			<PageHeader 
			backLocation="/play/" 
			label={i18n.t("ISSUE")}
			/>
			<div className="card montserratRegular">
			<br/>                
			<div>
			Please switch to mobile data to make your purchase for BIDNWIN


			</div> 
			<br/>
			<br/>
			<div style={{display:'flex',justifyContent: 'space-evenly'}} className="text-center">
			<PrimaryButton
			label="Back"
			onClick={()=> window.location.href = `${config.BILLING_URL}`}
		/>
			</div>               
			</div>
			</div>
	}
}

export default NoWifiPage;




// WEBPACK FOOTER //
// ./src/views/NoWifiPage/index.js